import { LoginError } from '@local/login/dist/components/loginError/LoginError';
import { LOGIN_COOKIES_DISABLED } from '@local/login/dist/strings';
import {
    Notification,
    NotificationType,
} from '@local/web-design-system/dist/components/Notification';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/GridLegacy';
import Link from '@mui/material/Link';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { LegacyLoginForm } from 'src/components/login/legacy-form';
import { getCurrentUserDetails } from 'src/utils/get-current-user-details';

import { loginFormI18n as i18n } from '../Login.i18n';
import { useStyles } from './LoginForm.styles';

const CookiesDisabledNotification = () => {
    const enabled = window.navigator.cookieEnabled;
    return !enabled ? (
        <Notification type={NotificationType.ERROR} message={LOGIN_COOKIES_DISABLED} />
    ) : null;
};

type LoginFormProps = {
    isValidateError: boolean;
};

export const LoginForm = ({ isValidateError }: LoginFormProps) => {
    const { classes } = useStyles();
    const intl = useIntl();

    const sqidUserEmail = useMemo(() => {
        if (!isValidateError) {
            return undefined;
        }
        const currentUserDetails = getCurrentUserDetails();
        return currentUserDetails?.data?.email;
    }, [isValidateError]);

    return (
        <form className={classes.form}>
            <Grid container className={classes.container}>
                <Grid item xs={12} className={classes.error}>
                    <LoginError />
                    <CookiesDisabledNotification />
                </Grid>
                <Grid item xs={12}>
                    {isValidateError && (
                        <Grid item className={classes.sqidError}>
                            <Alert severity="error">
                                {intl.formatMessage(i18n.legacyIdWarning.textPart1, {
                                    sqidUserEmail,
                                })}
                                <Link href="https://help.seequent.com/Imago/en-GB/Content/seequent-id.htm">
                                    {intl.formatMessage(i18n.legacyIdWarning.textPart2)}
                                </Link>
                                .
                            </Alert>
                        </Grid>
                    )}
                    <LegacyLoginForm />
                </Grid>
            </Grid>
        </form>
    );
};
